import axiosInstance from "./AxiosInstance";
const busUrl = "api/transport/buses";
const shiftUrl = "api/transport/shifts/";
const stopUrl = "api/transport/stops/";
const routeUrl = "api/transport/routes";
const routeStopSeqUrl = "api/transport/route-stop-sequence";
const passUrl = "api/transport/buspasses";

// bus
export function getAvailableBusApi(param = {}) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/transport/available-trip-bus?${fparam}`);
}
export function getBusListApi(filters = {}) {
  const params = new URLSearchParams({ ...filters });
  return axiosInstance.get(`${busUrl}?${params.toString()}`);
}

export function getBusApi(id) {
  return axiosInstance.get(`${busUrl}/${id}`);
}

export function createBusApi(data) {
  return axiosInstance.post(busUrl, data);
}

export function updateBusApi(id, data) {
  return axiosInstance.put(`${busUrl}/${id}`, data);
}

export function getShiftListApi(filters = {}) {
  const params = new URLSearchParams({ ...filters });
  return axiosInstance.get(`${shiftUrl}?${params.toString()}`);
}
export function getbustrips(busid, filters = {}) {
  const params = new URLSearchParams(filters).toString();
  return axiosInstance.get(`api/transport/bus-trip/${busid}?${params}`);
}
export const getBusTripsExport = (busid,param={}) => {
  const fparam=new URLSearchParams(param).toString()
  return axiosInstance.get(
    `api/transport/bus-trip/${busid}?${fparam}`,
    {
      responseType: "blob",
    }
  );
};
export function getShiftApi(id) {
  return axiosInstance.get(`${shiftUrl}${id}/`);
}

export function createShiftApi(data) {
  return axiosInstance.post(shiftUrl, data);
}

export function updateShiftApi(id, data) {
  return axiosInstance.put(`${shiftUrl}${id}/`, data);
}
export function getbustriplog(id, param = {}) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/transport/bus_trip_logs/${id}?${fparam}`);
}
export const getBusTripLogExport = (id,param={}) => {
  const fparam=new URLSearchParams(param).toString()
  return axiosInstance.get(
    `api/transport/bus_trip_logs/${id}?${fparam}`,
    {
      responseType: "blob",
    }
  );
};
export function getbusrepairlog(id, param = {}) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/transport/bus_repair_logs/${id}?${fparam}`);
}
export const getBusRepairLogExport = (id,param={}) => {
  const fparam=new URLSearchParams(param).toString()
  return axiosInstance.get(
    `api/transport/bus_repair_logs/${id}?${fparam}`,
    {
      responseType: "blob",
    }
  );
};
export function getlivestatus(id) {
  return axiosInstance.get(`api/transport/refresh_device_info/${id}`);
}
export function removeDeviceid(id) {
  return axiosInstance.patch(`api/transport/buses/${id}`);
}
export function getBusActivePassesApi(busId,filters = {}) {
  const params = new URLSearchParams({ ...filters });
  return axiosInstance.get(`api/transport/active_passes_for_a_bus/${busId}?${params.toString()}`);
}
// stop  ////
export function getStopListApi(filters = {}) {
  const params = new URLSearchParams({ ...filters });
  return axiosInstance.get(`${stopUrl}?${params.toString()}`);
}

export function getStopApi(id) {
  return axiosInstance.get(`${stopUrl}${id}/`);
}

export function createStopApi(data) {
  return axiosInstance.post(stopUrl, data);
}

export function updateStopApi(id, data) {
  return axiosInstance.put(`${stopUrl}${id}/`, data);
}
export function getStopActivePassApi(id, param = {}) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(
    `api/transport/stops/${id}/active_passes/?${fparam}`
  );
}

// route //

export function getRouteListApi(filters = {}) {
  const params = new URLSearchParams({ ...filters });
  return axiosInstance.get(`${routeUrl}?${params.toString()}`);
}

export function getRouteApi(id) {
  return axiosInstance.get(`${routeUrl}/${id}`);
}

export function createRouteApi(data) {
  return axiosInstance.post(routeUrl, data);
}
export function editRouteApi(data) {
  return axiosInstance.put(`${routeUrl}`, data);
}
export function gettripoptiondata(id, data = {}) {
  const param = new URLSearchParams(data).toString();
  return axiosInstance.get(
    `api/transport/trip-available-bus-driver/${id}?${param}`
  );
}
export function getroutemapdata(id) {
  return axiosInstance.get(`api/transport/route-map/${id}`);
}
export function gettrip(id, param = {}) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/transport/route-trip/${id}?${fparam}`);
}
export function gettripstop(id) {
  return axiosInstance.get(`api/transport/trip-stop-schedule/${id}`);
}
export function gettrippass(id) {
  return axiosInstance.get(`api/transport/trip-passes/${id}`);
}
export function createtrip(id, data) {
  return axiosInstance.post(`api/transport/route-trip/${id}`, data);
}
export function updatetrip(id, data) {
  return axiosInstance.put(`api/transport/route-trip/${id}`, data);
}
export function upadteTripTimeApi(id, data) {
  return axiosInstance.put(`api/transport/route-trip/${id}`, data);
}
export function upadteTripReplaceDriverApi(id, data) {
  return axiosInstance.put(`api/transport/route-trip/${id}`, data);
}
export function ReplaceBusApi(bus_id, data) {
  return axiosInstance.post(`api/transport/replace-bus-trip/${bus_id}`, data);
}
export function ChangeBusStatusApi(bus_id, data) {
  return axiosInstance.put(`api/transport/replace-bus-trip/${bus_id}`, data);
}
export function getReplaceBusOptionApi(bus_id) {
  return axiosInstance.get(`api/transport/replace-bus-trip/${bus_id}`);
}
export function updateRouteApi(data) {
  return axiosInstance.put(routeUrl, data);
}
export function deleteRouteApi(id) {
  return axiosInstance.delete(`${routeUrl}/${id}`);
}
export function getRouteStopSequenceApi(route_id) {
  return axiosInstance.get(`${routeStopSeqUrl}/${route_id}`);
}

export function createRouteStopSequenceApi(route_id, data) {
  return axiosInstance.post(`${routeStopSeqUrl}/${route_id}`, data);
}

export function getPassListApi(filters = {}) {
  const params = new URLSearchParams({ ...filters });
  return axiosInstance.get(`${passUrl}?${params.toString()}`);
}
export function getliveemployeelist(trip_id) {
  return axiosInstance.get(`api/transport/todays_boarding_log/${trip_id}`);
}
//trip
export function getCurrentTrip() {
  return axiosInstance.get('api/transport/current_bus_trips');
}
